import { useMutation } from '@tanstack/react-query';
import { fetchGql } from '@/lib/graphql_client';
import { LogoutDocument } from '@/gql/graphql';
import { keycloak } from '@/lib/keycloak';
import { useContextStore, activeContextStorage } from './context-store';

/**
 * Clear the active session — `logout` GraphQL mutation (ENT-88 R3), then clear
 * the local context store + persisted selection and trigger the Keycloak logout.
 *
 * The store is cleared and Keycloak logout fires on `onSettled` so the user is
 * logged out locally even if the server call fails.
 */
export function useLogout() {
  const clear = useContextStore((s) => s.clear);

  return useMutation({
    mutationFn: () => fetchGql(LogoutDocument),
    onSettled: () => {
      clear();
      activeContextStorage.clear();
      keycloak.logout();
    },
  });
}
